import { useState, useEffect } from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import { lazy, Suspense, memo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { LanguageProvider } from "./LanguageContext";
import UserProfile from "./Components/UserProfile";
import AllBookings from "./Components/AllBookings";
// import Register from "./Components/Register";

// Lazy-loaded components
const Home = lazy(() => import("./Components/Home"));
const Header = lazy(() => import("./Components/Header"));
const Loader = lazy(() => import("./Components/Loader"));
const ServicesPage = lazy(() => import("./Components/ServicesPage"));
const Footer = lazy(() => import("./Components/Footer"));
const AboutPrayagraj = lazy(() => import("./Components/AboutPrayagraj"));
const AboutPrayagraj2 = lazy(() => import("./Components/AboutPrayagraj2"));
const AboutUs = lazy(() => import("./Components/AboutUs"));
const ProductDescriptionPage = lazy(() => import("./Components/ProductDescriptionPage"));
const ContactPage = lazy(() => import("./Components/ContactPage"));
const TermsAndConditions = lazy(() => import("./Components/TermsAndConditions"));
const RefundAndCancellationPolicy = lazy(() => import("./Components/RefundAndCancellationPolicy"));
const PrivacyPolicy = lazy(() => import("./Components/PrivacyPolicy"));
const ResetPassword = lazy(() => import("./Components/ResetPassword"));
const ChangePassword = lazy(() => import("./Components/ChangePassword"));
const Register = lazy(() => import("./Components/Register"));
const Login = lazy(() => import("./Components/Login"));
// const Dashboard = lazy(() => import("./Components/Dashboard"));

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-5 right-5 p-3 bg-orange-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300"
        aria-label="Back to top"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    )
  );
};

const ProtectedRoute = ({ children, isAuthenticated, isLoading }) => {
  if (isLoading) {
    return <Loader />;
  }
  return isAuthenticated ? children : <Navigate to="/" />;
};

const HeaderLayout = memo(({ setIsProfileModalOpen }) => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
));

function App() {
  const [loading, setLoading] = useState(true);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  // const value = useSelector((state) => state.user_info);
  // const dispatch = useDispatch();


  // const isAuthenticated = value.length > 0 && value[0]?.role === 2;
  useEffect(() => {
    // Check if the sessionStorage already has the "isRefreshing" flag
    if (!sessionStorage.getItem('isRefreshing')) {
      // If not refreshing, set a flag to avoid removal on refresh
      sessionStorage.setItem('isRefreshing', 'true');
    }

    // Add event listener to remove data from localStorage before the window is unloaded
    const handleBeforeUnload = () => {
      // Only remove data if the page is being closed, not refreshed
      if (!sessionStorage.getItem('isRefreshing')) {
        localStorage.removeItem('__data'); // Remove '__data' only when tab/window is closed
      }
    };

    // Listen to beforeunload event
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      sessionStorage.removeItem('isRefreshing'); // Clear the flag when component unmounts or refresh
    };
  }, [])



  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <HeaderLayout setIsProfileModalOpen={setIsProfileModalOpen} />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/about", element: <AboutUs /> },
        { path: "/my-profile", element: <UserProfile /> },
        { path: "/sign-up", element: <Register /> },
        { path: "/login", element: <Login /> },
        { path: "/contact", element: <ContactPage /> },
        { path: "/refund-policy", element: <RefundAndCancellationPolicy /> },
        { path: "/all-bookings", element: <AllBookings /> },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
        { path: "/about-mahakumbh", element: <AboutPrayagraj /> },
        { path: "/services", element: <ServicesPage /> },
        { path: "/description", element: <ProductDescriptionPage /> },
        { path: "/terms-and-conditions", element: <TermsAndConditions /> },
        { path: "/about-prayagraj", element: <AboutPrayagraj2 /> },
        { path: "/reset-password", element: <ResetPassword /> },
        { path: "/change-password/:token", element: <ChangePassword /> },
        // {
        //   path: "/dashboard",
        //   element: (
        //     <ProtectedRoute isAuthenticated={isAuthenticated} isLoading={loading}>
        //       <Dashboard />
        //     </ProtectedRoute>
        //   ),
        // },
      ],
    },
  ]);

  return (
    <LanguageProvider>
      <Suspense fallback={<Loader />}>
        <RouterProvider router={appRouter} />
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <BackToTopButton />
        {/* <ProfileModal
        isOpen={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
        profileData={profileData}
      /> */}
      </Suspense>
    </LanguageProvider>
  );
}

export default App;
